import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProdutoList } from '../../models/produto-list.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { CadastroProdutoService } from '../../services/cadastro-produto.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-detalhe-cadastro-produto-list',
  templateUrl: './detalhe-cadastro-produto-list.component.html',
  styleUrls: ['./detalhe-cadastro-produto-list.component.scss']
})
export class DetalheCadastroProdutoListComponent extends BaseListComponent<ProdutoList> implements OnInit, OnDestroy {
  dtOptions1: any = {};
  lista1: ProdutoList[];
  alertas: string[];
  blocked: boolean;
  canCreateProduct: boolean;
  idProjeto: number;
  infoProjeto: any;
  permissions: ProjetoPermission;
  produtoList: ProdutoList[];
  produtoPesquisa: ProdutoList[];
  filterPesquisa: string = '';

  constructor(
    private myService: CadastroProdutoService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    if (this.idProjeto) {
      this.addSub(
        this.myService.getListAll(this.idProjeto).subscribe({
          next: (res) => {
            this.alertas = res['alertas'];
            this.blocked = res['blocked'];
            this.canCreateProduct = res['canCreateProduct'];
            this.produtoList = res['produtos'];
            this.produtoPesquisa = res['produtos'];
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error);
            this.loaded();
          },
        })
      );
    }
  }

  confirmExcluir(id: number) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error)
      }
    });
  }

  pesquisaRapida() {
    this.produtoPesquisa = this.produtoList.filter(item =>
      item['description'].toLowerCase().includes(this.filterPesquisa.toLowerCase())
    );
  }
}
